if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
				this.mainCart = document.querySelector("cart-items");

				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
			}
			delay(ms) {
				return new Promise((resolve) => setTimeout(resolve, ms));
			}
			// Fonction asynchrone qui utilise le délai
			asyncOperation = async (delay) => {
				await this.delay(delay);
			};

			onSubmitHandler(evt) {
				evt.preventDefault();

				/*
				 *
				 * On Submit if no variant are checked, return an error message
				 *
				 */

				this.elVariants = document.querySelector(".js-change-variant");
				if (this.elVariants) {
					this.elVariantChecked = this.elVariants?.querySelector("input[checked]");
					if (!this.elVariantChecked) return this.handleErrorMessage(this.elVariants.dataset.textSize);
				}

				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (document.querySelector("body").classList.contains("template-cart")) {
					if (this.mainCart) {
						formData.append(
							"sections",
							this.getSectionsToRenderMainCart().map((section) => section.section),
						);
						formData.append("sections_url", window.location.pathname);
					}
				} else {
					if (this.cart) {
						formData.append(
							"sections",
							this.cart.getSectionsToRender().map((section) => section.id),
						);
						formData.append("sections_url", window.location.pathname);
						this.cart.setActiveElement(document.activeElement);
					}
				}

				config.body = formData;
				// checks if the data-attribute 'componentBundleSubmit' of 'submitButton' is set to 'true'
				if (this.submitButton.dataset.componentBundleSubmit === "true") {
					// if that's the case, disable the 'submitButton'
					this.submitButton.disabled = true;
					// then, select all elements with 'data-component-bundle-variant' data-attribute and make an array out of them
					const allVariant = [...document.querySelectorAll("[data-component-bundle-variant]")];

					const allInputVariant = [...this.querySelectorAll("[data-component-bundle-input]")];
					const errorMessages = this.querySelector("[data-component-bundle-error]");
					allInputVariant.forEach((input) => {
						input.removeAttribute("data-sku");
					});
					errorMessages.classList.add("u-hidden");

					// then, for each of these selected elements
					allVariant.forEach((value) => {
						// get the previous sibling element, which is assumed to be an input
						const input = value.previousElementSibling;
						// check if this input is checked
						if (input.checked) {
							// if it is, uncheck it
							input.checked = false;
						}
					});
				}
				let delay = 0;
				if (this.classList.contains("is-quick-add") && !this.classList.contains("is-delivery-time")) {
					document.body.style.overflow = "auto";
					this.quickAddMobile = document.querySelector("[data-quick-add-mobile]");
					this.quickAddMobile.classList.remove("is-active");
				}
				if (this.classList.contains("is-delivery-time") && window.innerWidth < 992) {
					this.classList.add("is-active");
					delay = 1000;
				}
				this.asyncOperation(delay).then(() => {
					const allDeliveryTime = [...document.querySelectorAll(".delivery-time")];
					allDeliveryTime.forEach((value) => {
						value.classList.remove("is-active");
					});
					this.classList.remove("is-active");

					document.body.style.overflow = "auto";
					this.quickAddMobile = document.querySelector("[data-quick-add-mobile]");
					this.quickAddMobile.classList.remove("is-active");
					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
							if (document.querySelector("[data-component-personalisation]")) {
								document.querySelector("[data-component-personalisation-input]").value = "";
								[...document.querySelectorAll("[data-component-personalisation-color]")].forEach((item) => {
									item.classList.remove("is-active");
								});
								// document.querySelector(".js-product-add-to-cart").disabled = true;
							}

							if (response.status) {
								this.handleErrorMessage(response.description);

								const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButton.querySelector("span").classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!this.cart) {
								window.location = window.routes.cart_url;
								return;
							}

							this.error = false;

							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											this.cart.renderContents(response);
										});
									},
									{once: true},
								);
								quickAddModal.hide(true);
							} else {
								if (document.querySelector("body").classList.contains("template-cart")) {
									if (this.mainCart) {
										this.renderContentsMainCart(response);
									}
								} else {
									this.cart.renderContents(response);
								}
							}
						})
						.catch((e) => {
							console.error(e);
						})
						.finally(() => {
							this.submitButton.classList.remove("loading");
							if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
							if (!this.error) this.submitButton.removeAttribute("aria-disabled");
							this.cart.dispatchEvent(new Event("addToCartAfter"));
						});
				});
			}
			renderProductInfo() {
				const id = document.querySelector("[data-mutation-change-variant]").id;
				console.log(window.location.pathname);
				console.log(window.location.href);
				fetch(`${window.location.href}`)
					.then((response) => response.text())
					.then((responseText) => {
						console.log(responseText);
						const html = new DOMParser().parseFromString(responseText, "text/html");

						this.reRenderSection(html, id);
					});
			}
			reRenderSection(html, section) {
				console.log(section, html);
				const destinationAdd = document.getElementById(`${section}`);
				const sourceAdd = html.getElementById(`${section}`);
				if (sourceAdd && destinationAdd) destinationAdd.innerHTML = sourceAdd.innerHTML;
				const add = document.getElementById(`${section}`);

				if (add) add.classList.remove("visibility-hidden");
			}
			getSectionsToRenderMainCart() {
				return [
					{
						id: "main-cart-items",
						section: document.getElementById("main-cart-items").dataset.id,
						selector: ".js-contents",
					},
					{
						id: "cart-icon-bubble",
						section: "cart-icon-bubble",
						selector: ".shopify-section",
					},
					{
						id: "cart-live-region-text",
						section: "cart-live-region-text",
						selector: ".shopify-section",
					},
					{
						id: "main-cart-footer",
						section: document.getElementById("main-cart-footer").dataset.id,
						selector: ".js-contents",
					},
				];
			}

			renderContentsMainCart(parsedState) {
				this.getSectionsToRenderMainCart().forEach((section) => {
					if (!!section.section) {
						const elementToReplace =
							document.getElementById(section.id).querySelector(section.selector) ||
							document.getElementById(section.id);
						elementToReplace.innerHTML = this.getSectionInnerHTMLMainCart(
							parsedState.sections[section.section],
							section.selector,
						);
					}
				});
			}

			getSectionInnerHTMLMainCart(html, selector) {
				return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		},
	);
}
